export default "__VITE_ASSET__CnvsQKeN__"